import { render, staticRenderFns } from "./EditContent.vue?vue&type=template&id=6cab1b65&"
import script from "./EditContent.vue?vue&type=script&lang=js&"
export * from "./EditContent.vue?vue&type=script&lang=js&"
import style0 from "./EditContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSheet,VTextField})
